import { Chip, Stack, Tooltip } from '@mui/material';
import BoltRounded from '@mui/icons-material/BoltRounded';
import CelebrationRounded from '@mui/icons-material/CelebrationRounded';
import LaptopChromebookRounded from '@mui/icons-material/LaptopChromebookRounded';
import VerifiedRounded from '@mui/icons-material/VerifiedRounded';
import type { ProfileCard } from '@/api/types';

export function VerifiedBadge({ size = 'small' }: { size?: 'small' | 'medium' }) {
  return (
    <Tooltip title="A equipe conferiu o registro no conselho (CREF) deste profissional.">
      <Chip
        size={size}
        variant="soft"
        color="success"
        icon={<VerifiedRounded />}
        label="CREF verificado"
      />
    </Tooltip>
  );
}

/** The trust and convenience signals of a professional, most important first. */
export function ProfileBadges({
  card,
  max = 4,
  size = 'small',
}: {
  card: ProfileCard;
  max?: number;
  size?: 'small' | 'medium';
}) {
  const badges = [
    card.verified && <VerifiedBadge key="verified" size={size} />,
    card.fastResponder && (
      <Tooltip key="fast" title="Costuma responder os pedidos em menos de 24 horas.">
        <Chip
          size={size}
          variant="soft"
          color="accent"
          icon={<BoltRounded />}
          label="Responde rápido"
        />
      </Tooltip>
    ),
    card.trialClass && (
      <Chip
        key="trial"
        size={size}
        variant="soft"
        color="secondary"
        icon={<CelebrationRounded />}
        label="Aula experimental grátis"
      />
    ),
    card.serviceModes.includes('online') && (
      <Chip
        key="online"
        size={size}
        variant="soft"
        color="info"
        icon={<LaptopChromebookRounded />}
        label="Atende online"
      />
    ),
  ].filter(Boolean);
  if (!badges.length) return null;
  return (
    <Stack direction="row" useFlexGap sx={{ flexWrap: 'wrap', gap: 0.75 }}>
      {badges.slice(0, max)}
    </Stack>
  );
}
